import { SolidButton } from 'react-components'
import styled, { css } from 'styled-components'

export const Container = styled.div(
    ({ theme }) => css`
        width: ${theme.layout.fill};
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        border-top: ${theme.typography.border.width.xxxThin} solid #0000001a;
        background-color: white;
        padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
    `,
)

export const ButtonText = styled.strong`
    text-align: center;
    font: ${({ theme }) => `${theme.typography.font.weight.bold} ${theme.typography.font.size.small} /
        ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana}`};
`
export const SubmitButton = styled(SolidButton)<{ disabled: boolean }>(
    ({ disabled, theme }) => css`
        width: ${theme.layout.fill};
        display: flex;
        justify-content: center;
        ${disabled &&
        css`
            pointer-events: none;
            cursor: not-allowed;
        `};
    `,
)
